import { render } from "./Advice3.vue?vue&type=template&id=573a37f1&scoped=true"
import script from "./Advice3.vue?vue&type=script&lang=js"
export * from "./Advice3.vue?vue&type=script&lang=js"

import "./Advice3.vue?vue&type=style&index=0&id=573a37f1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573a37f1"]])

export default __exports__